import { useParams } from "react-router-dom";

export function useSubdomain() {
  const { subdomain } = useParams<{ subdomain?: string }>();

  return {
    subdomain: subdomain || null,
  };
}
